import { LayoutRoute, Route } from "@soft-db/typed-router";
import Login from "../pages/auth/login.vue";

const authRoutes = new LayoutRoute({
	name: "auth",
	path: "auth",
	meta: {
		ignoreAuth: true,
	},
	children: [
		new Route({
			path: "login",
			component: Login,
		}),
		new Route({
			path: "forgot",
			component: () => import("@/pages/auth/forgot.vue"),
		}),
		new Route({
			path: "action",
			component: () => import("@/pages/auth/action.vue"),
		}),
	],
});

export default authRoutes;
